<template>
    <div id="filter-popup" :style="popupPosition" :class="{_last: filterPopup.id == maxCols}">
        <div class="filter-header inline" valign="center">
            <div>{{ col.name }}<div @click="closeFilter" class="filter-trigger _open" :class="{_active: !$store.state.filters[$route.name][filterPopup.id]['all']}"></div></div>
        </div>
        <div class="filter-content">
            <div class="filter-search">
                <input type="text" placeholder="Поиск" class="_mini" v-model="search" />
            </div>
            <div class="checkbox selectAll">
                <input type="checkbox" :checked="$store.state.filters[$route.name][filterPopup.id]['all']" @change="change('all', !$store.state.filters[$route.name][filterPopup.id]['all'])" id="filterSelectAll" />
                <label for="filterSelectAll">Выбрать все</label>
            </div>
            <div class="checkbox" v-for="(item, key) in filerList" :key="key">
                <input type="checkbox" :checked="$store.state.filters[$route.name][filterPopup.id][key]" @change="change(key, !$store.state.filters[$route.name][filterPopup.id][key])" :id="'option'+key" />
                <label :for="'option'+key">{{ key }}</label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filterPopup', 'col', 'maxCols'],
        data () {
          return {
              search: ''
          }
        },
        methods: {
            closeFilter () {
                this.$emit('closeFilter')
            },
            change (name, value) {
                let data = {
                    page: this.$route.name,
                    colName: this.filterPopup.id,
                    fieldName: name,
                    value: value
                }
                this.$store.commit('filters/update_filter', data)
            },
            replaceSpanish (str) {
                return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            }
        },
        computed: {
            filerList () {
                let result = {}
                let filters = this.$store.state.filters[this.$route.name][this.filterPopup.id]
                for (let filterKey in filters) {
                    let key_lowercase = this.replaceSpanish(filterKey).toLowerCase()
                    let search = this.replaceSpanish(this.search).toLowerCase()
                    if (filterKey != 'all' && key_lowercase.indexOf(search) != -1) {
                        result[filterKey] = filters[filterKey]
                    }
                }
                return result
            },
            popupPosition () {
                return {
                    top: this.filterPopup.top + 'px',
                    left: this.filterPopup.left + 'px',
                    width: 'calc(' + this.filterPopup.width + 'px + 2px)'
                }
            }
        }
    }
</script>